import SearchPriceFinder from './SearchPriceFinder.component';
export default SearchPriceFinder;